import czFlag from '../assets/cz.png';
import enFlag from '../assets/gb.png';
import { Language } from '../types/translations';

export const czech: Language = {
    key: 'cs',
    label: 'Česky',
    flag: czFlag,
};

export const english: Language = {
    key: 'en',
    label: 'English',
    flag: enFlag,
};

export const languages = [english, czech];
